import type { IntlShape } from 'react-intl';

import type { TimeframeSelectorProps } from '../../../filters/timeframe-selector/TimeframeSelector.js';
import type { DateTimeError } from '../../date-time-range-picker/types.js';
import { getI18nErrorMessage } from '../../forms-core/hooks/useFormFieldValidation.js';
import { getOutsideRangeMessage } from '../../forms-core/time/timeParser.js';

export const getDateTimePickerError = (
  intl: IntlShape,
  formatString: string,
  error: DateTimeError,
  min?: string,
  max?: string,
  precision?: TimeframeSelectorProps['precision'],
) => {
  if (error === 'outsideRange') {
    return getOutsideRangeMessage(intl, min, max, precision);
  }

  if (error === 'valueMissing') {
    return getI18nErrorMessage('valueMissing');
  }

  if (error === 'invalid') {
    return intl.formatMessage(
      {
        defaultMessage: 'Invalid time. Expected format: {formatString} or -2h',
        id: 'ju/G1Pqs1RzpraAb',
        description: 'Given from and to values are invalid',
      },
      {
        formatString,
      },
    );
  }
};
